function reIndexSlide($slick){
  const $slides = $slick.find('.slick-slide:not(.slick-cloned)');
  $slides.each(function(index, slide) {
    $(slide).attr('data-slick-index', index);
  });
  $slick.slick('slickGoTo',0,true);
}

module.exports = {
  reIndexSlide
};



// WEBPACK FOOTER //
// ../assets/js/slick-reindex.js